import React from 'react';
import styles from '../../styles/effects/SnowEffect.module.scss';

const SnowEffect: React.FC = () => {
  const flakes = Array.from({ length: 80 }).map((_, i) => {
    const left = Math.random() * 100;
    const size = 2 + Math.random() * 4; // 2px–6px
    const fallDuration = 5 + Math.random() * 5; // 5s–10s
    const fallDelay = -Math.random() * fallDuration; // start at different times
    const swayDuration = 3 + Math.random() * 2; // 3s–5s
    const swayDelay = -Math.random() * swayDuration;
    const swayDist = 10 + Math.random() * 10; // 10px–20px

    return (
      <div
        key={i}
        className={styles.flake}
        style={
          {
            left: `${left}%`,
            width: `${size}px`,
            height: `${size}px`,
            animationDuration: `${fallDuration}s, ${swayDuration}s`,
            animationDelay: `${fallDelay}s, ${swayDelay}s`,
            '--sway-dist': `${swayDist}px`,
          } as React.CSSProperties
        }
      />
    );
  });

  return <div className={styles.snow}>{flakes}</div>;
};

export default SnowEffect;
